import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
} from '@mui/material';

import NoDataFound from '../../UI/NoDataFound';
import ICButton from '../../UI/IconButton';
import { PROTOCOL_TYPE } from '../../../utils/constants/common';

/*
 * createData used for filling data into Material UI table
 */

function createData(_id, date, drugName, premiumInventoryName, batchName, qty, protocol) {
  return {
    _id,
    date,
    drugName,
    premiumInventoryName,
    batchName,
    qty,
    protocol,
  };
}

export default function SavedTreatmentTable(props) {
  // Data to be appended
  const [rows, setRows] = useState([]);

  useEffect(() => {
    // set the data
    if (props.treatments) {
      let treatmentsListData = [];
      props.treatments.map((val) => {
        treatmentsListData.push(
          createData(
            val._id,
            moment(val.createdDate).format('DD-MM-YYYY'),
            val.drugName,
            val.premiumInventoryName,
            val.batchName,
            val.qty + ' ' + val.measure,
            val.protocolName
          )
        );
      });
      setRows(treatmentsListData);
    }
  }, [props.treatments]);

  return (
    <Paper sx={{ width: '100%' }}>
      <TableContainer className="primary-table-color scroll-table-ipad-max-height">
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>{`${props.protocolType === PROTOCOL_TYPE.OTHER ? 'Premium Inventory' : 'Drug'} Name`}</TableCell>
              <TableCell>{`${
                props.protocolType === PROTOCOL_TYPE.OTHER ? 'Premium Inventory' : 'Drug'
              } Name Batch`}</TableCell>
              <TableCell>Qty</TableCell>
              <TableCell>Protocol</TableCell>
              <TableCell className="action-table-cell">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Loop over the data (createData function) */}
            {rows.map((row, index) => {
              return (
                <TableRow hover key={index}>
                  <TableCell>{row.date} </TableCell>
                  <TableCell>
                    {props.protocolType === PROTOCOL_TYPE.OTHER
                      ? row.premiumInventoryName || '-'
                      : row.drugName || '-'}
                  </TableCell>
                  <TableCell>{row.batchName || '-'}</TableCell>
                  <TableCell>{row.qty} </TableCell>
                  <TableCell>{row.protocol} </TableCell>
                  <TableCell>
                    {' '}
                    <ICButton
                      title=""
                      type="button"
                      icon="fas fa-eye"
                      style={{ margin: 6 }}
                      className="only-icon blue"
                      clickEvent={() => {
                        props.editTreatment(row._id);
                      }}
                    />
                    <ICButton
                      title=""
                      type="button"
                      icon="fas fa-trash-alt"
                      style={{ margin: 6 }}
                      className="only-icon danger"
                      clickEvent={() => {
                        props.deleteTreatment(row._id);
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}

            {/*
             * No data fount if there are no data array in API
             */}
            {!rows.length && <NoDataFound colSpan={6} />}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
